module.exports = __webpack_public_path__ + "media/assets/images/logo_login-49220980019393196dfd20be2b80ed10.png";